module.exports = __webpack_public_path__ + "img/hr-puberty-decal-06.17bc1119.png";